import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
// import { BsCart2 } from "react-icons/bs";

import ProductCrousel from "./ProductCrousel";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsHome } from "../../../../Redux/App/action";

const AllProducts = () => {
  const dispatch = useDispatch();
  const { allProductsHome } = useSelector((store) => store.appReducer);

  useEffect(() => {
    dispatch(getAllProductsHome);
  }, [dispatch]);

  return (
    <>
      <Text
        className="oswald-font"
        color={"#3C375F"}
        fontSize={{ md: "25px", base: "20px" }}
        fontWeight={"bold"}
        letterSpacing={"0px"}
      >
        All Products
      </Text>
      <Text
        color={"#7D7D7D"}
        fontSize={{ md: 14, base: 10 }}
        className="lato-font"
        fontWeight={"regular"}
      >
        Shop Our Bestsellers - The Products That Everyone Is Buying
      </Text>
      <Box w={"100%"} display={{ md: "block", base: "none" }}>
        <ProductCrousel />
      </Box>
      <Box
        w={"100%"}
        display={{ base: "grid", md: "none" }}
        gridTemplateColumns={"repeat(2,1fr)"}
      >
        {allProductsHome &&
          allProductsHome.slice(0, 8).map((el, i) => (
            <Link key={i} to={`/productDetails/${el.productId}`}>
              <Box
                position="relative"
                w={{ md: "90%", base: "95%" }}
                key={i}
                mt={2}
              >
                <Image
                  src={el.img}
                  w={"100%"}
                  borderRadius={10}
                  h={{ md: 220, base: 160 }}
                />

                <Box>
                  <Text
                    color={"#06211A"}
                    letterSpacing={0}
                    fontSize={{ md: 14, base: 10 }}
                    fontWeight={"semibold"}
                  >
                    {el.productName}
                  </Text>
                  <Flex
                    gap={5}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    pr={5}
                  >
                    <Box>
                      <Flex gap={3}>
                        <Text
                          color={"#787A79"}
                          fontWeight={"bold"}
                          fontSize={{ md: 14, base: 10 }}
                        >
                          Price
                        </Text>
                        <Text
                          color={"#395D00"}
                          fontWeight={"bold"}
                          fontSize={{ md: 15, base: 10 }}
                          textDecoration={"line-through"}
                        >
                          ₹{el.priceDetails.price}
                        </Text>
                        <Text
                          color={"#395D00"}
                          fontWeight={"bold"}
                          fontSize={{ md: 15, base: 10 }}
                        >
                          ₹{el.priceDetails.sellingPrice}
                        </Text>
                      </Flex>
                    </Box>
                    {el.isAllVariantSoldOut ? (
                      <Box
                        position="absolute"
                        top="1"
                        left="1"
                        bg="black"
                        px={"7px"}
                        py={"4px"}
                        rounded="sm"
                        fontSize="10px"
                        fontWeight="semibold"
                        color={"white"}
                      >
                        SOLD OUT
                      </Box>
                    ) : (
                      <Box
                        position="absolute"
                        top="1"
                        left="1"
                        bg="#1E9C99"
                        px={"13px"}
                        py={"2px"}
                        rounded="md"
                        fontSize="10px"
                        fontWeight="semibold"
                        color={"white"}
                      >
                        {`${el.priceDetails.discountPercentage}% Off`}
                      </Box>
                    )}
                  </Flex>
                </Box>
              </Box>
            </Link>
          ))}
      </Box>
      <Flex justifyContent={"flex-end"}>
        <Link to={"/productPage"}>
          <Text
            mt={2}
            fontWeight={"semibold"}
            color={"#4295a4"}
            cursor={"pointer"}
            fontSize={{ md: "16px", base: "16px" }}
          >
            See More...
          </Text>
        </Link>
      </Flex>
    </>
  );
};

export default AllProducts;
